import Lang from 'lang.js'

const source =  {
    //'en.auth': require('Lang/en/auth.php'),
    'ru.actions': require('Lang/ru/actions.php'),
    'ru.contract': require('Lang/ru/contract.php'),
    'ru.filter': require('Lang/ru/filter.php'),
    'ru.messages': require('Lang/ru/messages.php'),
    'ru.comments': require('Lang/ru/comments.php'),
    'ru.labels': require('Lang/ru/labels.php'),
    'ru.listCategoryFile': require('Lang/ru/listCategoryFile.php'),
    'ru.config': require('Lang/ru/config.php'),
    'ru.sex': require('Lang/ru/sex.php'),
    'ru.case': require('Lang/ru/case.php'),
    'ru.contact': require('Lang/ru/contact.php'),
    'ru.channel': require('Lang/ru/channel.php'),
    'ru.table': require('Lang/ru/table.php'),
    'ru.statistic': require('Lang/ru/statistic.php'),
    'ru.dateRangePicker': require('Lang/ru/dateRangePicker.php'),
    'ru.payments': require('Lang/ru/payments.php'),
    'ru.client':require('Lang/ru/client.php'),
    'ru.clientField':require('Lang/ru/clientField.php'),
    'ru.modal':require('Lang/ru/modal.php'),
    'ru.backgroundOperation':require('Lang/ru/backgroundOperation.php'),
    'ru.timeline':require('Lang/ru/timeline.php'),
    'ru.datePicker':require('Lang/ru/datePicker.php'),

}

const locale=$('html').attr('lang');

const lang = new Lang({ 
    messages: source,
    locale: locale,
    fallback: 'en'
})

const __ = (key="",replace={},choice) =>{
    if(choice===undefined){
        if(typeof(replace)==="object")
            return lang.trans(key,replace);
        else{
            choice=replace;
            replace = {};
        }
    }
    return lang.choice(key,choice,replace);
}
const __all = (sourceName) =>{
    return lang.messages[lang.locale+'.'+sourceName]
}

window.__ = __;
window.lang = lang;
window.__all = __all;

export { __ as default, Lang, __ , __all};
